import { FileText, Loader2, CheckCircle2, XCircle, CalendarClock, Send } from 'lucide-react';

export const ITEM_STATUS = {
  planned: { color: 'bg-slate-500/20 text-slate-300 border-slate-500/40', icon: FileText, label: 'En attente' },
  generating: { color: 'bg-amber-500/20 text-amber-300 border-amber-500/40', icon: Loader2, label: 'Génération…', spin: true },
  generated: { color: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40', icon: CheckCircle2, label: 'Généré' },
  failed: { color: 'bg-red-500/20 text-red-300 border-red-500/40', icon: XCircle, label: 'Échec' },
  publishing: { color: 'bg-blue-500/20 text-blue-300 border-blue-500/40', icon: Loader2, label: 'Publication…', spin: true },
  scheduled: { color: 'bg-blue-500/20 text-blue-300 border-blue-500/40', icon: CalendarClock, label: 'Planifié' },
  published: { color: 'bg-green-500/20 text-green-300 border-green-500/40', icon: Send, label: 'Publié' },
  draft_wp: { color: 'bg-slate-500/20 text-slate-300 border-slate-500/40', icon: FileText, label: 'Brouillon WP' },
};

export const STATUS_COLOR = {
  draft: 'bg-slate-500/20 text-slate-300 border-slate-500/40',
  plan_generated: 'bg-cyan-500/20 text-cyan-300 border-cyan-500/40',
  articles_generating: 'bg-amber-500/20 text-amber-300 border-amber-500/40',
  ready_to_publish: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40',
  scheduled: 'bg-blue-500/20 text-blue-300 border-blue-500/40',
  published: 'bg-green-500/20 text-green-300 border-green-500/40',
  error: 'bg-red-500/20 text-red-300 border-red-500/40',
  cancelled: 'bg-slate-500/20 text-slate-400 border-slate-500/40',
};

export const LINKING_LEVELS = [
  { value: 'none', label: 'Aucun — Pas de liens internes' },
  { value: 'light', label: 'Léger — 1 lien vers le pilier' },
  { value: 'standard', label: 'Standard — Pilier + qq liens croisés' },
  { value: 'strong', label: 'Dense — Maillage complet' },
];

/**
 * Pré-rempli pour le modal de planification : J0 + offset à 9h00 Paris
 */
export function suggestedDateTime(j0Date, offsetDays) {
  const d = j0Date ? new Date(j0Date) : new Date(Date.now() + 24 * 3600 * 1000);
  d.setDate(d.getDate() + (offsetDays || 0));
  d.setHours(9, 0, 0, 0);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * Date par défaut pour la génération programmée (01h00)
 */
export function defaultScheduleDate() {
  const d = new Date();
  d.setHours(1, 0, 0, 0);
  if (d.getTime() <= Date.now()) {
    d.setDate(d.getDate() + 1);
  }
  const tz = d.getTimezoneOffset();
  const local = new Date(d.getTime() - tz * 60000);
  return local.toISOString().slice(0, 16);
}
